import { Box } from "@mui/material";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import EmployeeForm from "../../../components/FormEmployee";
import Header from "../../../components/Header";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const CreateEmployee = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const apiUrl = "https://oven-backend.onrender.com";


  const handleFormSubmit = async (values) => {
    try {
      const today = new Date().toISOString().split('T')[0];
      
      if (values.role === 'employee' && values.hire_date > today) {
        alert(t('future_date_error'));
        return;
      }
  
      const payload = {
        role: values.role,
        name: values.name,
        phone: values.phone,
        ...(values.role === 'employee' && {
          salary: Number(values.salary),
          hire_date: values.hire_date,
          city: values.city
        }),
        ...(values.role === 'supplier' && { companyName: values.companyName }),
        ...(values.role === 'customer' && { customerCode: values.customerCode })
      };
  
      const response = await axios.post(`${apiUrl}/employees`, payload ,{ withCredentials: true });
      setOpen(true);
      setTimeout(() => {
        navigate("/employee");
      }, 1000);
    } catch (error) {
      console.error(t('create_employee_error'), error.response?.data);
    }
  };

  return (
    <Box m="20px" sx={{ direction: isRTL ? 'rtl' : 'ltr' }}>
      <Header 
        title={t('create_employee')} 
        subtitle={t('create_employee_subtitle')} 
      />
      
      <EmployeeForm 
        initialValues={{ 
          name: "", 
          phone: "", 
          city: "", 
          salary: "", 
          hire_date: "" 
        }}
        handleFormSubmit={handleFormSubmit} 
        buttonLabel={t('create_employee_button')}
      />

      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <Alert 
          onClose={() => setOpen(false)}
          severity="success"
          variant="filled"
          sx={{ width: '100%', fontFamily: isRTL ? 'Cairo, sans-serif' : 'Roboto, sans-serif' }}
        >
          {t('success_added_employee')}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateEmployee;